import {
  YJCS_CHEQUE_ADD_NEW,
  YJCS_CHEQUE_ADD_NEW_SUCCESS,
  YJCS_CHEQUE_ADD_NEW_ERROR,
  YJCS_CHEQUE_DELETE,
  YJCS_CHEQUE_DELETE_ERROR,
  YJCS_CHEQUE_DELETE_SUCCESS,
  YJCS_CHEQUE_EDIT,
  YJCS_CHEQUE_EDIT_ERROR,
  YJCS_CHEQUE_EDIT_SUCCESS,
  YJCS_CHEQUE_GET_BY_ID,
  YJCS_CHEQUE_GET_BY_ID_ERROR,
  YJCS_CHEQUE_GET_BY_ID_SUCCESS,
  YJCS_CHEQUE_ADD_NEW_REQUEST,
  YJCS_CHEQUE_QUERY,
  YJCS_CHEQUE_QUERY_SUCCESS,
  YJCS_CHEQUE_QUERY_ERROR,
} from '../actions';

// yjcsCheques
const initialState = {
  yjcsCheques: [],
  yjcsCheque: null,
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case YJCS_CHEQUE_GET_BY_ID:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case YJCS_CHEQUE_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: true,
        yjcsCheque: payload,
      };

    case YJCS_CHEQUE_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };

    case YJCS_CHEQUE_QUERY:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case YJCS_CHEQUE_QUERY_SUCCESS:
      return {
        ...state,
        yjcsCheques: payload,
        loading: true,
      };
    case YJCS_CHEQUE_ADD_NEW:
      return {
        ...state,
        loading: false,
        error: null,
        addSuccess: false,
      };

    case YJCS_CHEQUE_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: true,
        yjcsCheque: payload,
        yjcsCheques: state.yjcsCheques.concat(payload),
        addSuccess: true,
      };

    case YJCS_CHEQUE_EDIT:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case YJCS_CHEQUE_EDIT_SUCCESS:
      return {
        ...state,
        loading: true,
        yjcsCheques: state.yjcsCheques.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        yjcsCheque: payload,
        error: null,
        editSuccess: true,
      };
    case YJCS_CHEQUE_DELETE:
      return {
        ...state,
        loading: false,
        error: null,
        deleteSuccess: false,
      };
    case YJCS_CHEQUE_DELETE_SUCCESS:
      return {
        ...state,
        loading: true,
        yjcsCheques: state.yjcsCheques.filter(c => c.id !== payload),
        deleteSuccess: true,
      };
    case YJCS_CHEQUE_QUERY_ERROR:
    case YJCS_CHEQUE_DELETE_ERROR:
    case YJCS_CHEQUE_ADD_NEW_ERROR:
    case YJCS_CHEQUE_EDIT_ERROR:
    case YJCS_CHEQUE_GET_BY_ID_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
